import { API_URL } from "./constants";

export const _organizationPrizes = async (data, state) => {
  var myHeaders = new Headers();
  myHeaders.append("Authorization", "Bearer " + state.user.user.token);
  myHeaders.append("Content-Type", "application/json");
  var requestOptions = {
    method: "GET",
    headers: myHeaders,
    redirect: "follow",
  };
  const response = await fetch(API_URL + "organization_prizes", requestOptions);
  const _data = await response.json();
  return { response, data: _data };
};

export const _createOrganization = async (data, state) => {
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: data,
    redirect: "follow",
  };
  const response = await fetch(
    "http://127.0.0.1:5000/v1/" + "organizations",
    requestOptions
  );
  const _data = await response.json();
  return { response, data: _data };
};

export const _addPrize = async (data, state) => {
  var myHeaders = new Headers();
  myHeaders.append("Authorization", "Bearer " + state.user.user.token);
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify(data);

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };
  const response = await fetch(API_URL + "add_prize", requestOptions);
  const _data = await response.json();

  return { response, data: _data };
};

export const _deletePrize = async (data, state) => {
  var myHeaders = new Headers();
  myHeaders.append("Authorization", "Bearer " + state.user.user.token);
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify(data);

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };
  const response = await fetch(API_URL + "delete_prize", requestOptions);
  const _data = await response.json();

  return { response, data: _data };
};

export const _editPrizes = async (data, state) => {
  var myHeaders = new Headers();
  myHeaders.append("Authorization", "Bearer " + state.user.user.token);
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify(data);

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };
  const response = await fetch(API_URL + "edit_prizes", requestOptions);
  const _data = await response.json();
  return { response, data: _data };
};

export const _organizationUsers = async (data, state) => {
  var myHeaders = new Headers();
  myHeaders.append("Authorization", "Bearer " + state.user.user.token);
  var requestOptions = {
    method: "GET",
    headers: myHeaders,
    redirect: "follow",
  };
  const response = await fetch(API_URL + "user", requestOptions);
  const _data = await response.json();
  return { response, data: _data };
};

export const _registerUser = async (data, state) => {
  var myHeaders = new Headers();
  myHeaders.append("Authorization", "Bearer " + state.user.user.token);
  myHeaders.append("Content-Type", "application/json");
  data["Web"] = true;
  data["password"] = "";
  var raw = JSON.stringify(data);

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };
  const response = await fetch(API_URL + "user", requestOptions);
  const _data = await response.json();
  return { response, data: _data };
};

export const _editProfile = async (data, state) => {
  var myHeaders = new Headers();
  myHeaders.append("Authorization", "Bearer " + state.user.user.token);
  myHeaders.append("Content-Type", "application/json");
  var raw = JSON.stringify(data);
  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };
  const response = await fetch(API_URL + "edit_profile", requestOptions);
  const data2 = await response.json();
  return { response, data: data2 };
};

export const _kickUsers = async (data, state) => {
  var myHeaders = new Headers();
  myHeaders.append("Authorization", "Bearer " + state.user.user.token);
  myHeaders.append("Content-Type", "application/json");
  var raw = JSON.stringify(data);
  console.log(raw);
  var requestOptions = {
    method: "DELETE",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };
  const response = await fetch(API_URL + "user", requestOptions);
  const data2 = await response.json();
  return { response, data: data2 };
};

export const _organizationName = async (data, state) => {
  var myHeaders = new Headers();
  myHeaders.append("Authorization", "Bearer " + state.user.user.token);
  myHeaders.append("Content-Type", "application/json");
  var raw = JSON.stringify(data);
  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };
  const response = await fetch(API_URL + "organization_name", requestOptions);
  const data2 = await response.json();
  return { response, data: data2 };
};

export const _organizationMoods = async (data, state) => {
  var myHeaders = new Headers();
  myHeaders.append("Authorization", "Bearer " + state.user.user.token);
  myHeaders.append("Content-Type", "application/json");
  var requestOptions = {
    method: "GET",
    headers: myHeaders,
    redirect: "follow",
  };
  const response = await fetch(API_URL + "organization_moods", requestOptions);
  const data2 = await response.json();
  return { response, data: data2 };
};

export const _organizationData = async (data, state) => {
  var myHeaders = new Headers();
  myHeaders.append("Authorization", "Bearer " + state.user.user.token);
  //myHeaders.append("Content-Type", "application/json");
  var requestOptions = {
    method: "GET",
    headers: myHeaders,
    redirect: "follow",
  };
  const response = await fetch(API_URL + "organization", requestOptions);
  const data2 = await response.json();
  return { response, data: data2 };
};

export const _changePassword = async (data) => {
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify(data);

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };
  const response = await fetch(
    API_URL + "change_password_token",
    requestOptions
  );
  const data2 = await response.json();
  return { response, data: data2 };
};

export const _addPoints = async (data, state) => {
  var myHeaders = new Headers();
  myHeaders.append("Authorization", "Bearer " + state.user.user.token);
  myHeaders.append("Content-Type", "application/json");
  var raw = JSON.stringify(data);
  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };
  const response = await fetch(API_URL + "add_user_points", requestOptions);
  const data2 = await response.json();
  return { response, data: data2 };
};

export const _chatReport = async (data, state) => {
  var myHeaders = new Headers();
  myHeaders.append("Authorization", "Bearer " + state.user.user.token);
  myHeaders.append("Content-Type", "application/json");
  var raw = JSON.stringify(data);
  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };
  const response = await fetch(
    API_URL + ("chat_report?id=" + data.id),
    requestOptions
  );
  const data2 = await response.json();
  return { response, data: data2 };
};

export const _organizationPoints = async (data, state) => {
  var myHeaders = new Headers();
  myHeaders.append("Authorization", "Bearer " + state.user.user.token);
  myHeaders.append("Content-Type", "application/json");
  var raw = JSON.stringify(data);
  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };
  const response = await fetch(API_URL + "organization_points", requestOptions);
  const data2 = await response.json();
  return { response, data: data2 };
};

export const _weeklyBonus = async (data, state) => {
  var myHeaders = new Headers();
  myHeaders.append("Authorization", "Bearer " + state.user.user.token);
  myHeaders.append("Content-Type", "application/json");
  var raw = JSON.stringify(data);
  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };
  const response = await fetch(API_URL + "weekly_bonus", requestOptions);
  const data2 = await response.json();
  return { response, data: data2 };
};

export const _organizationUpdate = async (data, state) => {
  var myHeaders = new Headers();
  myHeaders.append("Authorization", "Bearer " + state.user.user.token);
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify(data);

  var requestOptions = {
    method: "PUT",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };
  const response = await fetch(API_URL + "organizations", requestOptions);
  const data2 = await response.json();
  return { response, data: data2 };
};

export const _invitationCode = async (data, state) => {
  var myHeaders = new Headers();
  myHeaders.append("Authorization", "Bearer " + state.user.user.token);
  myHeaders.append("Content-Type", "application/json");
  var requestOptions = {
    method: "GET",
    headers: myHeaders,
    redirect: "follow",
  };
  const response = await fetch(API_URL + "invitation_code", requestOptions);
  const data2 = await response.json();
  return { response, data: data2 };
};

export const _userChats = async (data, state) => {
  var myHeaders = new Headers();
  myHeaders.append("Authorization", "Bearer " + state.user.user.token);
  myHeaders.append("Content-Type", "application/json");
  var requestOptions = {
    method: "GET",
    headers: myHeaders,
    redirect: "follow",
  };
  const response = await fetch(
    API_URL + ("user_chats?id=" + state.user.user.ID),
    requestOptions
  );
  const data2 = await response.json();
  return { response, data: data2 };
};

export const _scheduleReminder = async (data, state) => {
  var myHeaders = new Headers();
  myHeaders.append("Authorization", "Bearer " + state.user.user.token);
  myHeaders.append("Content-Type", "application/json");
  var raw = JSON.stringify(data);

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };
  const response = await fetch(API_URL + "schedule_reminder", requestOptions);
  const data2 = await response.json();
  return { response, data: data2 };
};

export const _generalReport = async (data, state) => {
  var myHeaders = new Headers();
  myHeaders.append("Authorization", "Bearer " + state.user.user.token);
  myHeaders.append("Content-Type", "application/json");
  var raw = JSON.stringify(data);
  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };
  const response = await fetch(API_URL + "general_report", requestOptions);
  const data2 = await response.json();
  return { response, data: data2 };
};

export const _organizationChats = async (data, state) => {
  var myHeaders = new Headers();
  myHeaders.append("Authorization", "Bearer " + state.user.user.token);
  myHeaders.append("Content-Type", "application/json");
  var requestOptions = {
    method: "GET",
    headers: myHeaders,
    redirect: "follow",
  };
  const response = await fetch(API_URL + "organization_chats", requestOptions);
  const data2 = await response.json();
  return { response, data: data2 };
};

export const _chatMessages = async (data, state) => {
  var myHeaders = new Headers();
  myHeaders.append("Authorization", "Bearer " + state.user.user.token);
  myHeaders.append("Content-Type", "application/json");
  var requestOptions = {
    method: "GET",
    headers: myHeaders,
    redirect: "follow",
  };
  const response = await fetch(
    API_URL + ("chat_messages?id=" + data.id),
    requestOptions
  );
  const data2 = await response.json();
  return { response, data: data2 };
};

export const _setPassword = async (data, state) => {
  var myHeaders = new Headers();
  myHeaders.append("Authorization", "Bearer " + state.user.user.token);
  myHeaders.append("Content-Type", "application/json");
  var raw = JSON.stringify({
    Mail: data.Mail,
  });
  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };
  const response = await fetch(API_URL + "send_password_token", requestOptions);
  const data2 = await response.json();
  return { response, data: data2 };
};

export const _getAllOrganizations = async (data, state) => {
  var myHeaders = new Headers();
  myHeaders.append("Authorization", "Bearer " + state.user.user.token);
  myHeaders.append("Content-Type", "application/json");
  var requestOptions = {
    method: "GET",
    headers: myHeaders,
    redirect: "follow",
  };
  const response = await fetch(API_URL + "organization", requestOptions);
  const data2 = await response.json();
  return { response, data: data2 };
};

export const _addOrganization = async (data, state) => {
  var myHeaders = new Headers();
  myHeaders.append("Authorization", "Bearer " + state.user.user.token);
  myHeaders.append("Content-Type", "application/json");
  var raw = JSON.stringify(data);
  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };
  const response = await fetch(API_URL + "organization", requestOptions);
  const data2 = await response.json();
  return { response, data: data2 };
};

export const _deleteOrganization = async (data, state) => {
  var myHeaders = new Headers();
  myHeaders.append("Authorization", "Bearer " + state.user.user.token);
  myHeaders.append("Content-Type", "application/json");
  var raw = JSON.stringify(data);
  var requestOptions = {
    method: "DELETE",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };
  const response = await fetch(API_URL + "organization", requestOptions);
  const data2 = await response.json();
  return { response, data: data2 };
};

export const _setRewardPoints = async (data, state) => {
  var myHeaders = new Headers();
  myHeaders.append("Authorization", "Bearer " + state.user.user.token);
  myHeaders.append("Content-Type", "application/json");
  var raw = JSON.stringify(data);

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };
  const response = await fetch(API_URL + "set_reward", requestOptions);
  const data2 = await response.json();
  return { response, data: data2 };
};

export const _setNotification = async (data, state) => {
  var myHeaders = new Headers();
  myHeaders.append("Authorization", "Bearer " + state.user.user.token);

  var method = data.method;
  if (method != "GET") myHeaders.append("Content-Type", "application/json");
  delete data["method"];
  var raw = JSON.stringify(data);

  var requestOptions = {
    method: method,
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };
  const response = await fetch(API_URL + "set_notification", requestOptions);
  const data2 = await response.json();
  return { response, data: data2 };
};

export const _requestMood = async (data, state) => {
  var myHeaders = new Headers();
  myHeaders.append("Authorization", "Bearer " + state.user.user.token);
  myHeaders.append("Content-Type", "application/json");

  var all_ids = [];
  state.user.organizationUsers.map((usr) =>
    usr.role === "User" ? all_ids.push(usr._id["$oid"]) : null
  );
  var raw = JSON.stringify({ users: all_ids });

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };
  const response = await fetch(API_URL + "request_mood", requestOptions);
  const data2 = await response.json();
  return { response, data: data2 };
};

export const _getNotifications = async (data, state) => {
  var myHeaders = new Headers();
  myHeaders.append("Authorization", "Bearer " + state.user.user.token);
  var requestOptions = {
    method: "GET",
    headers: myHeaders,
    redirect: "follow",
  };
  const response = await fetch(API_URL + "notifications", requestOptions);
  const data2 = await response.json();
  return { response, data: data2 };
};

export const _redeemHistory = async (data, state) => {
  var myHeaders = new Headers();
  myHeaders.append("Authorization", "Bearer " + state.user.user.token);
  myHeaders.append("Content-Type", "application/json");
  var requestOptions = {
    method: "GET",
    headers: myHeaders,
    redirect: "follow",
  };
  const response = await fetch(API_URL + "redeem_history", requestOptions);
  const data2 = await response.json();
  return { response, data: data2 };
};

export const _resetPasswordAdmin = async (data, state) => {
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("Authorization", "Bearer " + state.user.user.token);

  const raw = JSON.stringify(data);

  var requestOptions = {
    method: "PUT",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };

  const response = await fetch(API_URL + "reset_password", requestOptions);
  const _data = await response.json();
  return { response, data: _data };
};

export const _message = async (data, state) => {
  var messageURL = "message";
  var myHeaders = new Headers();
  myHeaders.append("Authorization", "Bearer " + state.user.user.token);
  var method = data.method;
  delete data["method"];
  var requestOptions = {
    method: method,
    redirect: "follow",
  };
  switch (method) {
    case "GET":
      messageURL += "?category=" + data.category;
      break;
  }

  var raw = JSON.stringify(data);
  requestOptions["headers"] = myHeaders;
  if (method != "GET") {
    requestOptions["body"] = raw;
  }
  const response = await fetch(API_URL + messageURL, requestOptions);
  const data2 = await response.json();
  return { response, data: data2 };
};

export const _getUserList = async (data, state) => {
  var myHeaders = new Headers();
  myHeaders.append("Authorization", "Bearer " + state.user.user.token);

  var requestOptions = {
    method: "GET",
    headers: myHeaders,
    redirect: "follow",
  };

  const response = await fetch(
    API_URL + "messages/" + data["messageStatus"],
    requestOptions
  );
  const _data = await response.json();
  return { response, data: _data };
};

export const _getUserMessage = async (data, state) => {
  var myHeaders = new Headers();
  myHeaders.append("Authorization", "Bearer " + state.user.user.token);

  var requestOptions = {
    method: "GET",
    headers: myHeaders,
    redirect: "follow",
  };

  const response = await fetch(
    API_URL + "message?caseId=" + data["caseId"],
    requestOptions
  );
  const _data = await response.json();
  return { response, data: _data };
};

export const _sendUserMessage = async (data, state) => {
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("Authorization", "Bearer " + state.user.user.token);

  const raw = JSON.stringify(data);

  var requestOptions = {
    method: "PUT",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };

  const response = await fetch(
    API_URL + "message?caseId=" + data["caseId"],
    requestOptions
  );
  const _data = await response.json();
  return { response, data: _data };
};

export const _requestCloseCase = async (data, state) => {
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("Authorization", "Bearer " + state.user.user.token);

  const raw = JSON.stringify(data);

  var requestOptions = {
    method: "DELETE",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };

  const response = await fetch(
    API_URL + "message?caseId=" + data["caseId"],
    requestOptions
  );
  const _data = await response.json();
  return { response, data: _data };
};
